import { ATTRS, TAGS } from '../constants';
import { EntitiesManager } from '../entitiesManager';
import { Entity } from '../types';
import { CropVarietyEntity } from './CropVariety';

export class CropTypeEntity implements Entity {
  public static fromXML(xml: any, matchIDs: any) {
    const attrs = xml._attributes;
    const isoId = attrs[ATTRS.CropType.CropTypeId];
    const id = matchIDs[isoId] ? matchIDs[isoId].id : null;

    const cropVarieties = (xml[TAGS.CropVariety] || []).map((cropVarietyXml) =>
      CropVarietyEntity.fromXML(cropVarietyXml, matchIDs)
    );

    return {
      entity: new CropTypeEntity(id, attrs[ATTRS.CropType.CropTypeDesignator], cropVarieties),
      isoId,
    };
  }

  public type = TAGS.CropType;

  constructor(
    public id: string,
    public designator: string,
    public cropVarieties: CropVarietyEntity[] = []
  ) {}

  public toXML(xmlId: string, entitiesManager: EntitiesManager) {
    return {
      _attributes: {
        [ATTRS.CropType.CropTypeId]: xmlId,
        [ATTRS.CropType.CropTypeDesignator]: this.designator,
      },
      [TAGS.CropVariety]: this.cropVarieties.map((cropVariety) =>
        cropVariety.toXML(entitiesManager.registerEntity(cropVariety))
      ),
    };
  }
}
